import { render, staticRenderFns } from "./SingleProduct.vue?vue&type=template&id=bfa72dec&scoped=true&"
import script from "./SingleProduct.vue?vue&type=script&lang=js&"
export * from "./SingleProduct.vue?vue&type=script&lang=js&"
import style0 from "./SingleProduct.vue?vue&type=style&index=0&id=bfa72dec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfa72dec",
  null
  
)

export default component.exports